import FormHeading from "../../components/formik/elements/FormHeading";
import React, { useEffect } from "react";
import {Form} from "react-bootstrap";
import {ErrorMessage, Formik} from "formik";
import FormButton from "../../components/formik/elements/Button";
import {loginUser} from "../../api/userApi";
import {useHistory, useLocation} from "react-router-dom"

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const LoginPage = () => {

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (document.getElementById("recaptcha-script")) return;

        const script = document.createElement("script");
        script.id = "recaptcha-script";
        script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }, []);

    const handleLogin = async (values, setSubmitting, setFieldError) => {
        setSubmitting(true);

        try {
            // Wait until grecaptcha is ready
            const recaptchaToken = await window.grecaptcha.execute(
                SITE_KEY,
                { action: "LOGIN" }
            );

            // Add token to request payload
            // const payload = {
            //     ...values,
            //     recaptchaToken
            // };

            localStorage.removeItem('token');
            localStorage.removeItem('user');

            const res = await loginUser(values, recaptchaToken);

            const { from } = location.state || { from: { pathname: '/cms' } };
            localStorage.setItem('token', res.headers.authorization);
            localStorage.setItem('user', JSON.stringify(res.data));
            history.push(from);

        } catch (err) {
            if (err.status === 401) {
                setFieldError("password", "Neteisingi prisijungimo duomenys");
            } else {
                setFieldError("password", "reCAPTCHA klaida!");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container-fluid col-xl-7">
            <FormHeading text="Reikalingas prisijungimas"/>
            <Formik
                initialValues={{username: "", password: ""}}
                onSubmit={({...values}, {
                    setSubmitting,
                    setFieldError
                }) => handleLogin(values, setSubmitting, setFieldError)}>
                {(formik) =>

                    <Form onSubmit={(e) => {
                        e.preventDefault();
                        formik.handleSubmit(e)
                    }}>
                        <Form.Label className="mt-3">Prisijungimo el. paštas:</Form.Label>
                        <Form.Control
                            type="text"
                            name="username"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <Form.Label className="mt-3">Slaptažodis:</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <ErrorMessage name="password" component="small" className="form__validation-error"/>
                        <div className="mt-3">
                            <FormButton type="submit" text="Prisijungti"/>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default LoginPage;